import {
	CLEAR_ORIGINATOR_MANAGEMENT_STATE,
	GET_ALL_ORIGINATORS,
	GET_ALL_ORIGINATORS_SUCCESS,
	GET_ALL_ORIGINATORS_ERROR,
	GET_ORIGINATOR_BY_ID,
	GET_ORIGINATOR_BY_ID_SUCCESS,
	GET_ORIGINATOR_BY_ID_ERROR,
	CREATE_ORIGINATOR,
	CREATE_ORIGINATOR_SUCCESS,
	CREATE_ORIGINATOR_ERROR,
	UPDATE_ORIGINATOR,
	UPDATE_ORIGINATOR_SUCCESS,
	UPDATE_ORIGINATOR_ERROR,
	DELETE_ORIGINATOR,
	DELETE_ORIGINATOR_SUCCESS,
	DELETE_ORIGINATOR_ERROR,
	GET_ORIGINATORS_STATUS,
	GET_ORIGINATORS_STATUS_SUCCESS,
	GET_ORIGINATORS_STATUS_ERROR,
	GET_OFFER_BY_ORIGINATOR,
	GET_OFFER_BY_ORIGINATOR_SUCCESS,
	GET_OFFER_BY_ORIGINATOR_ERROR,
	GET_ALL_INDUSTRY,
	GET_ALL_INDUSTRY_SUCCESS,
	GET_ALL_INDUSTRY_ERROR,
	GET_ALL_DOC_TYPE,
	GET_ALL_DOC_TYPE_SUCCESS,
	GET_ALL_DOC_TYPE_ERROR,
	GET_ALL_DOC_SUBTYPE,
	GET_ALL_DOC_SUBTYPE_SUCCESS,
	GET_ALL_DOC_SUBTYPE_ERROR,
	GET_ALL_USERS_BY_ORIGINATOR,
	GET_ALL_USERS_BY_ORIGINATOR_SUCCESS,
	GET_ALL_USERS_BY_ORIGINATOR_ERROR,
} from './actions';
import api from '@/utils/api';

const { http } = api.getInstance();
const USER_URL = '/users';
const ORIGINATOR_URL = '/originator';
const ORIGINATOR_STATUS_URL = '/originatorStatus';
const INDUSTRY_URL = '/industryType';
const DOC_TYPE_URL = '/docType';
const DOC_SUBTYPE_URL = '/docSubtype';

const defaultState = () => ({
	originatorList: [],
	originatorStatusList: [],
	originatorIndustryList: [],
	originatorDetail: null,
	isLoadingOriginators: '',
	originatorOffersList: [],
	isLoadingOriginatorOffers: '',
	originatorDocTypes: [],
	originatorDocSubtypes: [],
	originatorUsersList: [],
	isLoadingOriginatorUsers: '',
});

const state = defaultState();

const getters = {
	originatorList: (state) => state.originatorList,
	originatorStatusList: (state) => state.originatorStatusList,
	originatorIndustryList: (state) => state.originatorIndustryList,
	originatorDetail: (state) => state.originatorDetail,
	isLoadingOriginators: (state) => state.isLoadingOriginators === 'loading',
	originatorOffersList: (state) => state.originatorOffersList,
	isLoadingOriginatorOffers: (state) => state.isLoadingOriginatorOffers === 'loading',
	originatorDocTypes: (state) => state.originatorDocTypes,
	originatorDocSubtypes: (state) => state.originatorDocSubtypes,
	originatorUsersList: (state) => state.originatorUsersList,
	isLoadingOriginatorUsers: (state) => state.isLoadingOriginatorUsers === 'loading',
};

const mutations = {
	[CLEAR_ORIGINATOR_MANAGEMENT_STATE]: (state) => {
		Object.assign(state, defaultState());
	},
	[GET_ALL_ORIGINATORS]: (state) => {
		state.isLoadingOriginators = 'loading';
	},
	[GET_ALL_ORIGINATORS_SUCCESS]: (state, data) => {
		state.originatorList = data;
		state.isLoadingOriginators = 'success';
	},
	[GET_ALL_ORIGINATORS_ERROR]: (state) => {
		state.isLoadingOriginators = 'error';
	},
	[GET_ORIGINATOR_BY_ID]: (state) => {
		state.originatorDetail = null;
		state.isLoadingOriginators = 'loading';
	},
	[GET_ORIGINATOR_BY_ID_SUCCESS]: (state, data) => {
		state.originatorDetail = data;
		state.isLoadingOriginators = 'success';
	},
	[GET_ORIGINATOR_BY_ID_ERROR]: (state) => {
		state.originatorDetail = null;
		state.isLoadingOriginators = 'error';
	},
	[CREATE_ORIGINATOR]: (state) => {
		state.isLoadingOriginators = 'loading';
	},
	[CREATE_ORIGINATOR_SUCCESS]: (state) => {
		state.isLoadingOriginators = 'success';
	},
	[CREATE_ORIGINATOR_ERROR]: (state) => {
		state.isLoadingOriginators = 'error';
	},
	[UPDATE_ORIGINATOR]: (state) => {
		state.isLoadingOriginators = 'loading';
	},
	[UPDATE_ORIGINATOR_SUCCESS]: (state, data) => {
		state.isLoadingOriginators = 'success';
	},
	[UPDATE_ORIGINATOR_ERROR]: (state) => {
		state.isLoadingOriginators = 'error';
	},
	[DELETE_ORIGINATOR]: (state) => {
		state.isLoadingOriginators = 'loading';
	},
	[DELETE_ORIGINATOR_SUCCESS]: (state, data) => {
		state.isLoadingOriginators = 'success';
	},
	[DELETE_ORIGINATOR_ERROR]: (state) => {
		state.isLoadingOriginators = 'error';
	},
	[GET_ORIGINATORS_STATUS]: (state) => {
		state.originatorStatusList = [];
	},
	[GET_ORIGINATORS_STATUS_SUCCESS]: (state, data) => {
		state.originatorStatusList = data;
	},
	[GET_ORIGINATORS_STATUS_ERROR]: (state) => {
		state.originatorStatusList = [];
	},
	[GET_OFFER_BY_ORIGINATOR]: (state) => {
		state.originatorOffersList = [];
		state.isLoadingOriginatorOffers = 'loading';
	},
	[GET_OFFER_BY_ORIGINATOR_SUCCESS]: (state, data) => {
		state.originatorOffersList = data;
		state.isLoadingOriginatorOffers = 'success';
	},
	[GET_OFFER_BY_ORIGINATOR_ERROR]: (state) => {
		state.originatorOffersList = [];
		state.isLoadingOriginatorOffers = 'error';
	},
	[GET_ALL_INDUSTRY]: (state) => {
		state.originatorIndustryList = [];
	},
	[GET_ALL_INDUSTRY_SUCCESS]: (state, data) => {
		state.originatorIndustryList = data;
	},
	[GET_ALL_INDUSTRY_ERROR]: (state) => {
		state.originatorIndustryList = [];
	},
	[GET_ALL_DOC_TYPE]: (state) => {
		state.originatorDocTypes = [];
	},
	[GET_ALL_DOC_TYPE_SUCCESS]: (state, data) => {
		state.originatorDocTypes = data;
	},
	[GET_ALL_DOC_TYPE_ERROR]: (state) => {
		state.originatorDocTypes = [];
	},
	[GET_ALL_DOC_SUBTYPE]: (state) => {
		state.originatorDocSubtypes = [];
	},
	[GET_ALL_DOC_SUBTYPE_SUCCESS]: (state, data) => {
		state.originatorDocSubtypes = data;
	},
	[GET_ALL_DOC_SUBTYPE_ERROR]: (state) => {
		state.originatorDocSubtypes = [];
	},
	[GET_ALL_USERS_BY_ORIGINATOR]: (state) => {
		state.originatorUsersList = [];
		state.isLoadingOriginatorUsers = 'loading';
	},
	[GET_ALL_USERS_BY_ORIGINATOR_SUCCESS]: (state, data) => {
		state.originatorUsersList = data;
		state.isLoadingOriginatorUsers = 'success';
	},
	[GET_ALL_USERS_BY_ORIGINATOR_ERROR]: (state) => {
		state.originatorUsersList = [];
		state.isLoadingOriginatorUsers = 'error';
	},
};

const actions = {
	[GET_ALL_ORIGINATORS]: async ({ commit }, { vm, params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_ORIGINATORS);
			localStorage.setItem(`lastReqAdm`, 'originatorManagement/GET_ALL_ORIGINATORS');

			http({
				method: 'GET',
				url: `${ORIGINATOR_URL}${params}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_ORIGINATORS_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_ORIGINATORS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_ORIGINATOR_BY_ID]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ORIGINATOR_BY_ID);

			http({
				method: 'GET',
				url: `${ORIGINATOR_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ORIGINATOR_BY_ID_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ORIGINATOR_BY_ID_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[CREATE_ORIGINATOR]: async ({ commit }, { vm, body }) => {
		return new Promise((resolve, reject) => {
			commit(CREATE_ORIGINATOR);

			http({
				method: 'POST',
				url: `${ORIGINATOR_URL}?language=pt-br`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Originador criado com sucesso.');
					commit(CREATE_ORIGINATOR_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(CREATE_ORIGINATOR_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[UPDATE_ORIGINATOR]: async ({ commit }, { vm, id, body }) => {
		return new Promise((resolve, reject) => {
			commit(UPDATE_ORIGINATOR);

			http({
				method: 'PATCH',
				url: `${ORIGINATOR_URL}/${id}?language=pt-br`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Originador editado com sucesso.');
					commit(UPDATE_ORIGINATOR_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(UPDATE_ORIGINATOR_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[DELETE_ORIGINATOR]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(DELETE_ORIGINATOR);

			http({
				method: 'DELETE',
				url: `${ORIGINATOR_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Originador excluído com sucesso.');
					commit(DELETE_ORIGINATOR_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(DELETE_ORIGINATOR_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_ORIGINATORS_STATUS]: async ({ commit }, { vm }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ORIGINATORS_STATUS);

			http({
				method: 'GET',
				url: `${ORIGINATOR_STATUS_URL}?language=pt-br`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ORIGINATORS_STATUS_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ORIGINATORS_STATUS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_ALL_INDUSTRY]: async ({ commit }, { vm }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_INDUSTRY);

			http({
				method: 'GET',
				url: `${INDUSTRY_URL}?language=pt-br`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_INDUSTRY_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_INDUSTRY_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_OFFER_BY_ORIGINATOR]: async ({ commit }, { vm, id, params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_OFFER_BY_ORIGINATOR);

			http({
				method: 'GET',
				url: `${ORIGINATOR_URL}/${id}/offers${params}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_OFFER_BY_ORIGINATOR_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_OFFER_BY_ORIGINATOR_ERROR);
				});
		});
	},
	[GET_ALL_DOC_TYPE]: async ({ commit }, { vm }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_DOC_TYPE);

			http({
				method: 'GET',
				url: `${DOC_TYPE_URL}?language=pt-br`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_DOC_TYPE_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_DOC_TYPE_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_ALL_DOC_SUBTYPE]: async ({ commit }, { vm }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_DOC_SUBTYPE);

			http({
				method: 'GET',
				url: `${DOC_SUBTYPE_URL}?language=pt-br`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_DOC_SUBTYPE_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_DOC_SUBTYPE_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_ALL_USERS_BY_ORIGINATOR]: async ({ commit }, { vm, originator, params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_USERS_BY_ORIGINATOR);
			localStorage.setItem(`lastReqAdm`, 'originatorManagement/GET_ALL_USERS_BY_ORIGINATOR');

			http({
				method: 'GET',
				url: `${USER_URL}/all-users?search=${originator}${params}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_USERS_BY_ORIGINATOR_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_USERS_BY_ORIGINATOR_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
